import React, { useEffect, useState, useMemo } from 'react';
import {
  Container, Typography, Button, Snackbar, Alert, Box, IconButton, Tooltip
} from '@mui/material';
import { Add, Edit, Delete } from '@mui/icons-material';
import axios from 'axios';
import {
  MaterialReactTable,
  useMaterialReactTable
} from 'material-react-table';
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR';
import { useNavigate } from 'react-router-dom';
import { Visibility } from '@mui/icons-material';


const API_URL = process.env.REACT_APP_API_URL;

export default function Promocoes() {
  const [promocoes, setPromocoes] = useState([]);
  const [snackbar, setSnackbar] = useState({ open: false, mensagem: '', tipo: 'success' });
  const navigate = useNavigate();

  useEffect(() => {
    fetchPromocoes();
  }, []);

  const fetchPromocoes = async () => {
    try {
      const token = localStorage.getItem('token');
      const res = await axios.get(`${API_URL}/promocoes`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setPromocoes(res.data);
    } catch {
      setSnackbar({ open: true, mensagem: 'Erro ao carregar promoções.', tipo: 'error' });
    }
  };

  const handleExcluir = async (id) => {
    try {
      const token = localStorage.getItem('token');
      await axios.delete(`${API_URL}/promocoes/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      fetchPromocoes();
      setSnackbar({ open: true, mensagem: 'Promoção excluída com sucesso!', tipo: 'success' });
    } catch {
      setSnackbar({ open: true, mensagem: 'Erro ao excluir promoção.', tipo: 'error' });
    }
  };

  const columns = useMemo(() => [
    { accessorKey: 'id', header: 'ID', size: 80 },
    { accessorKey: 'nome', header: 'Nome' },
    { accessorKey: 'dias_pagos', header: 'Dias Pagos' },
    { accessorKey: 'dias_ganhos', header: 'Dias Ganhos' },
    {
      accessorKey: 'valor_diaria',
      header: 'Valor da Diária',
      Cell: ({ cell }) => `R$ ${parseFloat(cell.getValue()).toFixed(2).replace('.', ',')}`,
    },
    {
      accessorKey: 'ativa',
      header: 'Ativa',
      Cell: ({ cell }) => cell.getValue() ? 'Sim' : 'Não'
    },
    {
      id: 'acoes',
      header: 'Ações',
      Cell: ({ row }) => (
        <Box sx={{ display: 'flex', gap: 1 }}>
          <Tooltip title="Visualizar">
      <IconButton onClick={() => navigate(`/promocoes/${row.original.id}/visualizar`)}>
        <Visibility sx={{ color: "#1976d2" }} />
      </IconButton>
    </Tooltip>
          <Tooltip title="Editar">
            <IconButton onClick={() => navigate(`/promocoes/${row.original.id}/editar`)}>
              <Edit sx={{ color: "#ed3237" }} />
            </IconButton>
          </Tooltip>
          <Tooltip title="Excluir">
            <IconButton color="error" onClick={() => handleExcluir(row.original.id)}>
              <Delete />
            </IconButton>
          </Tooltip>
        </Box>
      )
    }
  ], [navigate]);

  const table = useMaterialReactTable({
    columns,
    data: promocoes,
    localization: MRT_Localization_PT_BR,
    enableColumnFilters: true,
    enableGlobalFilter: true,
    enablePagination: true,
    enableSorting: true,
    initialState: {
      pagination: { pageSize: 50, pageIndex: 0 }
    },
    muiTablePaperProps: {
      elevation: 3,
      sx: { borderRadius: 2, mt: 3 }
    },
    muiTableContainerProps: {
      sx: { maxHeight: '65vh', overflowY: 'auto' }
    },
    muiTableHeadCellProps: {
      sx: { backgroundColor: "#f9f9f9", fontWeight: 'bold', color: '#333' }
    },
  });

  return (
    <Container maxWidth="" sx={{ mt: 4, mb: 4 }}>
      <Typography variant="h6" sx={{ mt: 5, mb: 3 }}>
        Promoções
      </Typography>

      <Button
        variant="contained"
        startIcon={<Add sx={{ color: '#ed3237' }} />}
        onClick={() => navigate('/promocoes/nova')}
        sx={{
          backgroundColor: "#3e4095",
          fontWeight: "bold",
          color: "#ffffff",
          "&:hover": {
            backgroundColor: "#333",
            boxShadow: "0 0 0 2px #ed3237 inset",
          }
        }}
      >
        Adicionar
      </Button>

      <MaterialReactTable table={table} />

      <Snackbar open={snackbar.open} autoHideDuration={3000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
        <Alert severity={snackbar.tipo} sx={{ width: '100%' }}>
          {snackbar.mensagem}
        </Alert>
      </Snackbar>
    </Container>
  );
}
